import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class TransactionFailedError extends CodedError {
  static get errorName() {
    return errorCodes.transactionFailedError.code;
  }

  constructor(message: string = errorCodes.transactionFailedError.message) {
    super(message);
    this.code = errorCodes.transactionFailedError.code;
    this.message = `${message} ${errorCodes.transactionFailedError.code}`;
    this.name = errorCodes.transactionFailedError.name;
  }
}
